import MatchStatistic from '../../../interfaces/matchStatistic';

export default function getMatchStatisticForType(
  matchStatistics: Array<MatchStatistic>,
  teamId: number,
  matchStatisticsTypeId: number,
): MatchStatistic | null {
  for (const matchStatistic of matchStatistics) {
    if (matchStatistic.teamId === teamId && matchStatistic.matchStatisticsTypeId === matchStatisticsTypeId) {
      return matchStatistic;
    }
  }
  return null;
}
